import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { getGridLayout, gridItemStyles, GridProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-grid-item',
  template: `<div [ngClass]="gridItem"><ng-content></ng-content></div>`,
})
export class GridItemComponent implements OnInit {
  /**
   * Css del componente
   */
  @Input() css: GridProps['css'];

  styled: string;

  @HostBinding('style') get style() {
    return this.styled;
  }

  /**
   * Rows
   */
  _rowSpan: number;

  @Input() get rowSpan() {
    return this._rowSpan;
  }

  set rowSpan(value: number) {
    this._rowSpan = value;
    this.styled = getGridLayout(this.colSpan, value);
  }

  /**
   * Columnas
   */
  _colSpan: number;

  @Input() get colSpan() {
    return this._colSpan;
  }

  set colSpan(value: number) {
    this._colSpan = value;
    this.styled = getGridLayout(value, this.rowSpan);
  }

  public get gridItem(): string[] {
    return [
      gridItemStyles({
        css: this.css,
      }).className,
    ];
  }

  ngOnInit() {
    this.styled = getGridLayout(this.colSpan, this.rowSpan);
  }
}
